import { Lockup } from '@beyond-js/ui/react';
import wordmark from '@brand/beyond-logo-wordmark.svg';

/**
 * The Beyond wordmark, with the product name beside it: the family lockup of `@beyond-js/ui`.
 *
 * The asset is the captured family wordmark, byte for byte, and its geometry and colours are not
 * changed: one wordmark serves both appearances, as the source does, and no dark, reversed or
 * monochrome variant is invented here. The shared lockup sets "Accounts" beside it, sized and aligned
 * to the wordmark's letters, so it reads as product identification and never as part of the logo.
 */
export function Wordmark({ label }: { label?: string }) {
	return <Lockup src={wordmark} name={label} />;
}
